/* Pure cart planning; also loaded by the regression tests. Prices are Shopify cents. */
(function (root) {
  "use strict";
  var sizes = { single: 1, bogo: 2, crew: 4, collection: 6 };
  function parse(title) {
    var m = /^(\d+) Silver \/ (\d+) Gold$/i.exec(title || "");
    if (m) return { silver: +m[1], gold: +m[2] };
    if (/^Silver$/i.test(title)) return { silver: 1, gold: 0 };
    if (/^Gold$/i.test(title)) return { silver: 0, gold: 1 };
    return null;
  }
  function identify(item, catalog) {
    return Object.keys(sizes).find(function (id) {
      return catalog[id] && catalog[id].variants.some(function (v) { return String(v.id) === String(item.variant_id); });
    });
  }
  function totals(cart, catalog) {
    return cart.items.reduce(function (sum, item) {
      if (!identify(item, catalog)) return sum;
      var c = parse(item.variant_title);
      if (!c) throw new Error("Unrecognised bracelet colour mix: " + item.variant_title);
      sum.silver += c.silver * item.quantity; sum.gold += c.gold * item.quantity;
      return sum;
    }, { silver: 0, gold: 0 });
  }
  function cheapest(n, prices) {
    var dp = [{ cost: 0, bundles: [] }];
    for (var i = 1; i <= n; i++) {
      dp[i] = { cost: Infinity, bundles: [] };
      Object.keys(sizes).reverse().forEach(function (id) {
        var size = sizes[id], prev = dp[i - size];
        if (!prev || !Number.isFinite(prices[id])) return;
        var cost = prev.cost + prices[id];
        if (cost < dp[i].cost || (cost === dp[i].cost && prev.bundles.length + 1 < dp[i].bundles.length)) {
          dp[i] = { cost: cost, bundles: [id].concat(prev.bundles) };
        }
      });
    }
    if (!Number.isFinite(dp[n].cost)) throw new Error("No bundle combination available for " + n + " bracelets.");
    return dp[n];
  }
  function plan(colours, catalog) {
    Object.keys(sizes).forEach(function (id) {
      var vs = catalog[id] && catalog[id].variants;
      if (!vs || !vs.length) throw new Error("Select all four bracelet products in the Cart drawer settings.");
      if (vs.some(function (v) { return v.price !== vs[0].price; })) throw new Error("All variants of " + id + " must have the same price.");
    });
    var prices = {};
    Object.keys(sizes).forEach(function (id) { prices[id] = catalog[id].variants[0].price; });
    var best = cheapest(colours.silver + colours.gold, prices);
    // Backtrack colour allocation so sold-out mixes do not force a false failure.
    var memo = {};
    function allocate(index, silver, gold) {
      if (index === best.bundles.length) return silver === 0 && gold === 0 ? [] : null;
      var key = index + ":" + silver + ":" + gold;
      if (memo[key]) return null;
      var id = best.bundles[index], count = sizes[id];
      for (var s = Math.min(count, silver); s >= Math.max(0, count - gold); s--) {
        var g = count - s, title = count === 1 ? (s ? "Silver" : "Gold") : s + " Silver / " + g + " Gold";
        var v = catalog[id].variants.find(function (x) { return x.title === title && x.available; });
        if (!v) continue;
        var rest = allocate(index + 1, silver - s, gold - g);
        if (rest) return [{ id: v.id, quantity: 1, bundle: id }].concat(rest);
      }
      memo[key] = true; return null;
    }
    var lines = allocate(0, colours.silver, colours.gold);
    if (!lines) throw new Error("The selected colour mix is unavailable at the best bundle price. Your cart has not changed.");
    return { cost: best.cost, lines: lines };
  }
  root.StellanBundlePricing = { sizes: sizes, parse: parse, identify: identify, totals: totals, cheapest: cheapest, plan: plan };
})(typeof window === "undefined" ? globalThis : window);